import React from "react";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import clsx from "clsx";

const FeatureSection = ({ feature, textLeft = false, imageWidth = 680, imageHeight = 646 }) => {
  const { t } = useTranslation("features");

  return (
    <div
      className={clsx(
        "flex flex-col items-start gap-8 py-16 lg:flex-row lg:gap-16 lg:py-32",
        textLeft && "lg:flex-row-reverse lg:justify-between"
      )}
    >
      <div className="shrink-0">
        <Image src={`/features/${feature}.png`} alt={t(`${feature}.title`)} width={imageWidth} height={imageHeight} />
      </div>
      <div className="lg:mt-28">
        <div className="font-title text-lg font-semibold lg:text-3xl">{t(`${feature}.title`)}</div>
        {/* <div className="mt-2 text-grey-700 lg:mt-6 lg:text-xl">{t(`${feature}.description`)}</div> */}
      </div>
    </div>
  );
};

export default FeatureSection;
